if (sentryConfig)
{
	window.Sentry = require('@sentry/browser');

	sentryConfig.integrations = [new Sentry.Integrations.Vue({
		Vue,
		attachProps: true
	})];

	Sentry.init(sentryConfig);

	if (userId)
	{
		Sentry.configureScope((scope) => {
			scope.setUser({"id": userId});
		});
	}
}
